import React, {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import styles from "./AdminPreview.module.css";
import LoaderGraph from "../../general/LoaderGraph";
import moment from "moment-timezone";

const AdminSiteResponse = (props) => {
    const [row, setRow] = useState([]);

    // sd = site data
    const sd = Array.isArray(props.dataResponse) ? props.dataResponse : {};

    const rowRendered = (data) => {
        let sql = "";
        let res = "";

        if (data.error !== undefined) {
            sql = data.sql;
            res = data.sqlMessage;
        } else {
            const raw_sql = data[0].split(";");
            sql = raw_sql[1];
            const raw_res = data[1];
            if (raw_res.note !== undefined) res = raw_res.note;
            else {
                if (typeof raw_res[1] !== "object") {res = "";}
                else {
                    const object_res = Object.entries(raw_res[1]).map(([k, v]) => {
                        return `${k}: ${v} \n`;
                    });
                    res = object_res;
                }
            }
        }

        return (<Row style={{marginBottom: "10px"}}>
            <Col sm={8}><p>{sql}</p></Col>
            <Col sm={4}><p>{res}</p></Col>
        </Row>);
    };

    useEffect(() => {
        if (Array.isArray(sd)) {
            const length = sd.length;
            const tempRow = [];
            for (let i = 0; i < length; i++) {
                tempRow.push(rowRendered(sd[i]));
            }

            setRow(tempRow);
        }
    }, [sd]);

    return (
        <div className={`form-contents ${styles.adminPreview}`}>
            {Array.isArray(sd) > 0 ? (
                <div>
                    <Row>
                        <Col sm="11"></Col>
                        <Col sm="1">
                            <span
                                onClick={() => props.closed()}
                                style={{float: "right", cursor: "pointer"}}
                                className="glyphicon glyphicon-remove close-approval"
                            ></span>
                        </Col>
                    </Row>
                    {row.length > 0 && row.map((v) => v)}
                </div>
            ) : (
                <LoaderGraph />
            )}

            <div className="btn-container">
                <Row>
                    <Col md="3"></Col>
                    <Col md="3">
                        <button
                            className="btn btn-primary btn-generate btn-approval"
                            title="Close"
                            onClick={() => props.closed()}
                        >
                            <span>Close</span>
                        </button>
                    </Col>
                    <Col md="3"></Col>
                </Row>
            </div>
        </div>
    );
};

export default AdminSiteResponse;
